import React from 'react';
import InputText from '../../../../../components/modalComponents/InputText';
import InputSelect from '../../../../../components/modalComponents/InputSelect';
import CargosMultiselect from '../../UI/CargosMultiselect';
import './Step1InformacionBasica.css';

/**
 * Componente para el Paso 1: Información Básica
 * Diseño UX/UI moderno con transiciones suaves
 * Incluye: nombre, tipo de prueba, tipo de cargo, cargos específicos y encabezado
 * 
 * @version 2.0.0 - Rediseño completo UX/UI
 */
const Step1InformacionBasica = ({
  formData,
  errors,
  tiposPrueba,
  tiposCargo,
  cargosEspecificos,
  loadingCargos,
  handleInputChange,
  handleSelectChange,
  handleCargoChange,
  handleMarcarTodosCargos,
  handleSubtipoPsicologicaChange
}) => {
  const normalizarTexto = (texto = '') =>
    texto
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();

  const tipoSeleccionado = tiposPrueba.find(tp => String(tp.value) === String(formData.tipoPrueba));
  const esTipoPsicologica = normalizarTexto(tipoSeleccionado?.label || tipoSeleccionado?.nombre || '').includes('psicolog');

  const opcionesPsicologicas = [
    { value: 'salamanca', label: 'Salamanca' },
    { value: 'personalidad', label: 'DASS-21' }
  ];

  return (
    <div className="step1-container">
      <div className="step1-card">
        {/* Encabezado de Sección */}
        <div className="step1-section-header">
          <h2 className="step1-section-title">
            <span className="step1-section-icon">📝</span>
            Información Básica
          </h2>
          <p className="step1-section-subtitle">
            Completa los datos principales de la evaluación
          </p>
        </div>

        {/* Nombre de la Evaluación */}
        <div className="step1-form-group">
          <InputText
            label="Nombre de la Evaluación"
            name="nombreEvaluacion"
            value={formData.nombreEvaluacion}
            onChange={handleInputChange}
            isRequired={true}
            hasValidationMessage={true}
            validationMessage={errors.nombreEvaluacion}
            direction="column"
            placeholder="Ej: Evaluación técnica profesor de inicial"
            className="step1-input-wrapper"
          />
        </div>

        {/* Tipo de Prueba y Tipo de Cargo */}
        <div className="step1-form-row">
          <div className="step1-form-col">
            <InputSelect
              label="Tipo de Prueba"
              options={tiposPrueba}
              value={(() => {
                const found = tiposPrueba.find(tp => tp.value == formData.tipoPrueba);
                return found ? { value: found.value, label: found.label } : null;
              })()}
              onChange={handleSelectChange}
              name="tipoPrueba"
              placeholder="Seleccionar tipo de prueba"
              isRequired={true}
              hasValidationMessage={true}
              validationMessage={errors.tipoPrueba}
              direction="column"
              className="step1-select-wrapper"
            />
          </div>
          <div className="step1-form-col">
            <InputSelect
              label="Tipo de Cargo"
              options={tiposCargo}
              value={(() => {
                const found = tiposCargo.find(tc => tc.value == formData.idTipoCargo);
                return found ? { value: found.value, label: found.label } : null;
              })()}
              onChange={handleSelectChange}
              name="idTipoCargo"
              placeholder="Seleccionar tipo de cargo"
              isRequired={true}
              hasValidationMessage={true}
              validationMessage={errors.idTipoCargo}
              direction="column"
              className="step1-select-wrapper"
            />
          </div>
        </div>

        {esTipoPsicologica && (
          <div className="step1-form-group step1-psico-tags-group">
            <label className="step1-psico-tags-label">
              Categoría Prueba Psicológica <span className="text-danger">*</span>
            </label>
            <div className="step1-psico-tags-container">
              {opcionesPsicologicas.map(opcion => {
                const isActive = formData.subtipoPruebaPsicologica === opcion.value;
                return (
                  <button
                    key={opcion.value}
                    type="button"
                    className={`step1-psico-tag ${isActive ? 'active' : ''}`}
                    onClick={() => handleSubtipoPsicologicaChange(opcion.value)}
                  >
                    {opcion.label}
                  </button>
                );
              })}
            </div>
            {errors.subtipoPruebaPsicologica && (
              <div className="step1-validation-message">
                <span className="step1-validation-icon">⚠</span>
                <span>{errors.subtipoPruebaPsicologica}</span>
              </div>
            )}
          </div>
        )}

        <hr className="step1-divider" />
        
        {/* Cargos Específicos - Componente mejorado */}
        <CargosMultiselect
          formData={formData}
          errors={errors}
          cargosEspecificos={cargosEspecificos}
          loadingCargos={loadingCargos}
          handleCargoChange={handleCargoChange}
          handleMarcarTodosCargos={handleMarcarTodosCargos}
        />
        
        <hr className="step1-divider" />
        
        {/* Encabezado / Descripción Corta */}
        <div className="step1-form-group">
          <InputText
            label="Encabezado / Descripción Corta"
            name="encabezadoDescripcion"
            value={formData.encabezadoDescripcion}
            onChange={handleInputChange}
            isRequired={false}
            hasValidationMessage={false}
            direction="column"
            placeholder="Descripción opcional de la evaluación (máx. 200 caracteres)"
            className="step1-input-wrapper"
          />
          <div className="step1-info-badge">
            💡 Este texto aparecerá como descripción breve de la evaluación
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step1InformacionBasica;
